import React from 'react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function BonusIntro() {
  return <section className="py-10 bg-slate-900" data-id="element-23">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-24">
        <ScrollFadeIn data-id="element-25">
          <p className="text-2xl md:text-3xl font-serif text-slate-50 mb-8 leading-relaxed" data-id="element-26">
            But before you click the button below…
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-27">
          <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-28">
            I want to make sure you have everything you need to succeed — not
            just the manual, but the exact tools to use it from day one.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.2} data-id="element-29">
          <p className="text-lg text-slate-300 leading-relaxed mb-6" data-id="element-30">
            So I'm including three bonuses that work alongside The Cortisol
            Switch to make the process faster, simpler, and more sustainable.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.3} data-id="element-31">
          <p className="text-lg text-slate-300 leading-relaxed mb-10" data-id="element-32">
            These aren't "extra PDFs" thrown in to inflate the offer. Each one
            solves a specific problem that comes up during the first two weeks
            of the protocol.
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.4} data-id="element-33">
          <p className="text-xl font-medium text-amber-500" data-id="element-34">
            Here's what's included:
          </p>
        </ScrollFadeIn>
      </div>
    </section>;
}